export const styles = {
	paper: {
		marginTop: 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		'& .login_form': {
			width: '100%', // Fix IE 11 issue.
			marginTop: 1
		}
	},
	avatar: {
		margin: 1,
		backgroundColor: 'secondary.main'
	}
};
